import axios from 'axios'
import qs from 'qs'

import changeCaseKeys from 'helpers/changeCase/keys'

import { getBaseURL } from './env'
import * as service from 'service'
import history from 'service/history'
import { routes } from 'Routes'

export const create = (projectTag, treatError = true) => {
  let api = axios.create({ baseURL: getBaseURL(projectTag) })

  api.interceptors.request.use((reqConfig) => {
    const authToken = service.dponet.auth.getToken()

    if (authToken) {
      reqConfig.headers.Authorization = `${authToken}`
    }

    reqConfig.headers.crossDomain = true
    reqConfig.data = changeCaseKeys.snakeCase(reqConfig.data)
    reqConfig.params = changeCaseKeys.snakeCase(reqConfig.params)

    reqConfig.paramsSerializer = (params) => {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false,
      })
    }

    return reqConfig
  })

  api.interceptors.response.use(
    (resp) => changeCaseKeys.camelCase(resp),
    (error) => {
      if (treatError) {
        if (error && error.response && 401 === error.response.status) {
          service.dponet.auth.logout()
          return Promise.reject(changeCaseKeys.camelCase(error))
        }
        if (error && error.response && 404 === error.response.status) {
          if (!error?.params?.listAnswersOrigin) {
            history.push(routes.notFound)
            return Promise.reject(changeCaseKeys.camelCase(error))
          }
        }

        if (error && error.response && error.response.status === 403) {
          history.push(routes.forbidden)
          return Promise.reject(changeCaseKeys.camelCase(error))
        }
      }
      return Promise.reject(changeCaseKeys.camelCase(error))
    },
  )

  return api
}

const api = { create }

export default api
